export type Lodging = {
    id: string
    name: string
    shortDescription: string,
    description: string
    size: number
    bathrooms: number
    beds: number
    attributes: LodgingAttributes[]
    photos: string[]
    video: string
    previewImage: string
}

export enum LodgingAttributes {
    POOL = "pool",
    KITCHEN = "kitchen",
    TV = "tv",
    PRIVATE_BATHROOM = "privateBathroom",
    WASHING_MACHINE = "washingMachine",
    OVEN = "oven",
    MICROWAVE = "microwave",
    PHON = "phon",
    AIR_CONDITIONER = "airConditioner",
    WIFI = "wifi",
    FREE_PARKING = "freeParking",
    HEATING = "heating"
}